import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end my-4" }
const _hoisted_2 = { class: "flex h-4/5" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "w-5/6" }
const _hoisted_5 = { class: "flex items-end" }
const _hoisted_6 = { class: "ml-2 text-xs text-gray-500" }
const _hoisted_7 = { class: "text-xs text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_9 = { class: "w-1/6" }
const _hoisted_10 = { class: "flex min-h-52 w-108 gap-x-2" }
const _hoisted_11 = { class: "flex flex-col w-1/2" }
const _hoisted_12 = { class: "flex flex-col w-1/2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Members", -1)
const _hoisted_14 = { class: "overflow-y-auto max-h-40" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "flex items-center justify-between py-1" }
const _hoisted_20 = { class: "w-full text-sm" }

import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { cloneDeep } from 'lodash';
import Button from '@/components/UI/Button.vue';
import { useWrestlerStore } from '@/store/wrestlers';
import { Team } from '@/typings/wrestler';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import VirtualList from '@/components/UI/VirtualList.vue';
import { PromptModal } from '@/typings/modal';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const promptModal = inject('promptModal') as Ref<PromptModal>;

const creationModalVisible = ref(false);
const newTeam = ref<Team>({} as Team);

const wrestlerStore = useWrestlerStore();

function openCreate() {
  newTeam.value = {
    Members: [],
    Name: '',
    ScorecardName: '',
    TeamId: 0,
  };
  creationModalVisible.value = true;
}

function editTeam(editingTeam: Team) {
  newTeam.value = cloneDeep(editingTeam);
  creationModalVisible.value = true;
}

async function deleteTeam(deletingTeam: Team) {
  const doDelete = await promptModal.value.show(
    'Remove Team',
    'You are about to remove a team, are you sure?'
  );
  if (doDelete) {
    await wrestlerStore.deleteTeam(deletingTeam);
  }
}

async function saveModal() {
  if (newTeam.value.TeamId) {
    await wrestlerStore.editTeam(newTeam.value);
  } else {
    await wrestlerStore.addTeam(newTeam.value);
  }
  creationModalVisible.value = false;
}

const modalHeader = computed(() =>
  newTeam.value?.TeamId ? 'Edit a team' : 'Set up a team'
);

function getWrestlerName(id: number) {
  return (
    wrestlerStore.wrestlers.find((w) => w.SuperstarId === id)?.Name || '...'
  );
}

const newMember = ref('');

function addMember() {
  const input = parseInt(newMember.value, 10);
  if (newMember.value && !newTeam.value.Members.includes(input)) {
    newTeam.value.Members.push(input);
    newMember.value = '';
  }
}

function removeMember(index: number) {
  newTeam.value.Members.splice(index, 1);
}

onMounted(async () => {
  if (wrestlerStore.wrestlers.length === 0) await wrestlerStore.getWrestlers();
  wrestlerStore.getTeams();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Button, {
        label: "Add Team",
        onClick: openCreate
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(VirtualList, {
        ref: (_value, _refs) => {
          _refs['list'] = _value
        },
        "item-size": 52,
        data: _unref(wrestlerStore).teams,
        "data-key": "SuperstarId"
      }, {
        default: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, _toDisplayString(item.Name), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.ScorecardName), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Members, (memberId, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: item.TeamId + ' ' + memberId
                  }, [
                    _createElementVNode("span", null, _toDisplayString(getWrestlerName(memberId)), 1),
                    (index !== item.Members.length - 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_8
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(Button, {
                class: "cursor-pointer",
                onClick: ($event: any) => (editTeam(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa_icon, { icon: "pencil-alt" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(Button, {
                class: "cursor-pointer",
                onClick: ($event: any) => (deleteTeam(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa_icon, { icon: "trash" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    (newTeam.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Save",
              onClick: saveModal
            }),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(TextField, {
                  modelValue: newTeam.value.Name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTeam.value.Name) = $event)),
                  title: "Name",
                  "max-length": 150
                }, null, 8, ["modelValue"]),
                _createVNode(TextField, {
                  modelValue: newTeam.value.ScorecardName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTeam.value.ScorecardName) = $event)),
                  title: "Twitter Name",
                  "max-length": 36
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newTeam.value.Members, (member, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index + member,
                      class: _normalizeClass([
              'flex items-center justify-between py-1',
              {
                'border-b': index !== newTeam.value.Members.length - 1,
              },
            ])
                    }, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(getWrestlerName(member)), 1),
                      _createElementVNode("div", {
                        class: "text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-red-500 hover:opacity-100",
                        onClick: ($event: any) => (removeMember(index))
                      }, [
                        _createVNode(_component_fa_icon, { icon: "minus" })
                      ], 8, _hoisted_16)
                    ], 2))
                  }), 128))
                ]),
                (newTeam.value.Members.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Empty"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(SearchDropdown, {
                        title: "New Member",
                        modelValue: newMember.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newMember).value = $event)),
                        items: _unref(wrestlerStore).wrestlerSearchOptions
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _createElementVNode("div", {
                      class: "mt-4 text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-green-500 hover:opacity-100",
                      onClick: addMember
                    }, [
                      _createVNode(_component_fa_icon, { icon: "plus" })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})